import { NotificationModel } from "./notification-model"

export type NotificationSeverity = "INFO" | "WARNING" | "ERROR" | "CRITICAL"

const prefKeys = [
    {pref: "daysTillArchive", key: "smrtlink.notifications.days_till_archive" },
    {pref: "isByEmail", key: "smrtlink.notifications.is_by_email" },
    {pref: "emailAddress", key: "smrtlink.notifications.email_address" },
    {pref: "notifyOnUpdate", key: "smrtlink.notifications.notify_on_update" },
    {pref: "notifyOnWarning", key: "smrtlink.notifications.notify_on_warning" },
    {pref: "notifyOnError", key: "smrtlink.notifications.notify_on_error" },
    {pref: "includeInfos", key: "smrtlink.notifications.include_infos" },
    {pref: "includeWarnings", key: "smrtlink.notifications.include_warnings" },
    {pref: "includeErrors", key: "smrtlink.notifications.include_errors" },
    {pref: "includeCriticals", key: "smrtlink.notifications.include_criticals" }
]

const registrationPrefKeys = [
    {pref: "modalDismissed", key: "smrtlink.registration.modal_dismissed" }
]

export interface UserPreferences {
    notificationPreferences?: NotificationsPreferences
    registrationPreferences?: RegistrationPreferences
}

export interface NotificationsPreferences {
    daysTillArchive?: number
    isByEmail?: boolean
    emailAddress?: string
    notifyOnUpdate?: boolean
    notifyOnWarning?: boolean
    notifyOnError?: boolean
    includeInfos?: boolean
    includeWarnings?: boolean
    includeErrors?: boolean
    includeCriticals?: boolean
}

// Controls the on-prem server registration modal. modalDismissed is the admin's
// "Don't show again" choice.
export interface RegistrationPreferences {
    modalDismissed?: boolean
}

export const defaultUserPreference: UserPreferences = {
    notificationPreferences: {
        daysTillArchive: 14,
        isByEmail: false,
        emailAddress: null,
        notifyOnUpdate: false,
        notifyOnWarning: false,
        notifyOnError: false,
        includeInfos: true,
        includeWarnings: true,
        includeErrors: true,
        includeCriticals: true
    },
    registrationPreferences: {
        modalDismissed: false
    }
}

type UserPreferencesJson = {
    key: string
    value: any
}[]

export const jsonToUserPreferences = (json: UserPreferencesJson): UserPreferences => {
    const notificationPrefs = {}
    const registrationPrefs = {}
    for (let keyValue of json) {
        const {key, value} = keyValue
            const prefKey = prefKeys.find( prefKey => prefKey.key === key)
            if (prefKey) {
                notificationPrefs[prefKey.pref] = value
            }
            const registrationPrefKey = registrationPrefKeys.find( prefKey => prefKey.key === key)
            if (registrationPrefKey) {
                registrationPrefs[registrationPrefKey.pref] = value
            }
    }
    const userPreferences: UserPreferences = {}
    if (Object.keys(notificationPrefs).length > 0) {
        userPreferences.notificationPreferences = notificationPrefs
    }
    if (Object.keys(registrationPrefs).length > 0) {
        userPreferences.registrationPreferences = registrationPrefs
    }
    return userPreferences
}

export const userPreferencesToJson = (prefs: UserPreferences): UserPreferencesJson => {
    const json = []

    const notificationPrefs = prefs.notificationPreferences
    if (notificationPrefs) {
        for (let prefKey of prefKeys) {
            const { pref, key} = prefKey
            if (pref in notificationPrefs) {
                json.push( {
                    key: key,
                    value: notificationPrefs[pref]
                })
            }
        }
    }

    const registrationPrefs = prefs.registrationPreferences
    if (registrationPrefs) {
        for (let prefKey of registrationPrefKeys) {
            const { pref, key} = prefKey
            if (pref in registrationPrefs) {
                json.push( {
                    key: key,
                    value: registrationPrefs[pref]
                })
            }
        }
    }
    return json
}

export const includeNotification = (notification: NotificationModel, prefs: NotificationsPreferences):boolean => {
    if (prefs) {
        switch( notification.severity) {
            // update this when there is more clarity from mkting
            case "INFO":
                if ( !prefs.includeInfos ) return false
                break
            case "WARNING":
                if ( !prefs.includeWarnings ) return false
                break
            case "ERROR":
                if ( !prefs.includeErrors ) return false
                break
            case "CRITICAL":
                if ( !prefs.includeCriticals ) return false
                break
            default: 
        }
        return true //unreachable, but needed to prevent "not all code paths return" lint error.
    } else {
        return true
    }
   
}